import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar/Navbar'
import ScrollToTop from './components/ScrollToTop'
import HomeScreen from './screens/HomeScreen/HomeScreen'
import ServicesScreen from './screens/ServicesScreen/ServicesScreen'
import Footer from './components/Footer/Footer'
import './App.css'
import AboutScreen from './screens/AboutScreen/AboutScreen'
import ContactScreen from './screens/ContactScreen/ContactScreen'
import { ErrorBoundary } from 'react-error-boundary'

const AppLayout = () => {
  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/thjonusta" element={<ServicesScreen />} />
          <Route path="/um-okkur" element={<AboutScreen />} />
          <Route path="/hafa-samband" element={<ContactScreen />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert" style={{ padding: '20px' }}>
      <h2>Something went wrong:</h2>
      <pre style={{ color: 'red' }}>{error.message}</pre>
    </div>
  )
}

// Root component with Router
function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Router>
        <AppLayout />
      </Router>
    </ErrorBoundary>
  );
}

export default App
